// src/pages/OauthCallback.tsx
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import Spinner from '../components/Spinner'

export default function OauthCallback() {
  const navigate = useNavigate()
  const LS_POST_LOGIN_REDIRECT = 'postLoginRedirect'

  useEffect(() => {
    const hash = window.location.hash || ''
    const m = hash.match(/customToken=([^&]+)/)
    const customToken = m ? decodeURIComponent(m[1]) : null

    if (!customToken) {
      // nothing to do, go to login
      navigate('/login', { replace: true })
      return
    }

    const auth = getAuth()
    signInWithCustomToken(auth, customToken)
      .then(() => {
        // optional: read where to go from localStorage
        const target = localStorage.getItem(LS_POST_LOGIN_REDIRECT) || '/'
        localStorage.removeItem(LS_POST_LOGIN_REDIRECT)
        navigate(target, { replace: true })
      })
      .catch((err) => {
        console.error('custom token sign-in failed', err)
        navigate('/login', { replace: true })
      })
  }, [navigate])

  return (
    <div className="container page">
      <Spinner label="Signing you in…" />
    </div>
  )
}
